import { Component, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  date = new Date();

  constructor(
    private titleService: TitleService,
    private authService: AuthenticationService,
    private jwtHelperSrv: JwtHelperService,
    private userService: UserService,
    private dataService: DataService

  ) { }

  ngOnInit(): void {
    this.titleService.title.next('Accueil');

    const date2 = new Date(localStorage.getItem('bizz-ffv-token-exp'));

    if (localStorage.getItem('bizz-ffv-token-exp') && this.date > date2) {
      this.authService.refreshToken().subscribe(() => {
        this.getMenu();
      });
    }
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }



}
